import { Workflow } from '../../constants/Workflow';

export const allowMultipleVehicles = (workflow: Workflow) => {
  return workflow === Workflow.checklight;
};
